// extracted by mini-css-extract-plugin
export default {"slideContainer":"_696eefa72d f752a3e043 fd11f5dd5f","slideImage":"e7a93c0a5f"};